import React from 'react'
import { Modal, ModalHeader, ModalBody } from 'reactstrap'
import ErrorBoundary from 'components/ErrorBoundary'
import Loading from 'components/Loading/Loading'
import EditLicenseModal from 'components/EditLicenseModal'
import { AssignNetSuiteAsset } from 'components/SetupNetSuiteAsset'

// Import custom hook and components
import { useContractLine } from './hooks/useContractLine'
import ContractLineHeader from './components/ContractLineHeader'
import ContractLineSections from './components/ContractLineSections'
import ContractLineNotFound from './components/ContractLineNotFound'
import ContractLineSummary from './ContractLineSummary'

const ContractLine: React.FC = () => {
  const {
    contractLineDetails,
    isLoading,
    selectedAsset,
    setupModalOpen,
    editModalOpen,
    setSelectedAsset,
    setSetupModalOpen,
    backToSearch,
    setupLicense,
    toggleSetupModal,
    toggleEditModal,
    loadContractLine,
  } = useContractLine()

  // Show not found state if contract line doesn't exist and not loading
  if (contractLineDetails.contractLineId === undefined && !isLoading) {
    return (
      <ContractLineNotFound
        isLoading={isLoading}
        onBackToSearch={backToSearch}
      />
    )
  }

  return (
    <ErrorBoundary>
      <ContractLineHeader
        contractLineId={contractLineDetails.contractLineId}
        onBackToSearch={backToSearch}
      />

      <Loading isLoading={isLoading} />

      <ContractLineSummary contractLineDetails={contractLineDetails} />

      <ContractLineSections
        products={contractLineDetails.products}
        unassignedAssets={contractLineDetails.unassignedAssets}
        assignedAssets={contractLineDetails.assignedAssets}
        onSetupLicense={setupLicense}
        onEditLicense={toggleEditModal}
      />

      {selectedAsset && setupModalOpen && (
        <Modal
          backdrop="static"
          centered
          fade
          isOpen={setupModalOpen}
          size="lg"
          toggle={toggleSetupModal}
        >
          <ModalHeader toggle={toggleSetupModal}>Setup License</ModalHeader>
          <ModalBody>
            <AssignNetSuiteAsset
              netSuiteAsset={selectedAsset}
              clearSelectedAsset={() => {
                setSelectedAsset(null)
                setSetupModalOpen(false)
              }}
              onAssignmentSuccess={loadContractLine}
            />
          </ModalBody>
        </Modal>
      )}

      {selectedAsset && editModalOpen && (
        <EditLicenseModal
          isOpen={editModalOpen}
          netSuiteAsset={selectedAsset}
          toggle={() => toggleEditModal(selectedAsset)}
        />
      )}
    </ErrorBoundary>
  )
}

export default ContractLine
